import { render, staticRenderFns } from "./RegistrationsTable.vue?vue&type=template&id=a7c75e9c&scoped=true&"
import script from "./RegistrationsTable.vue?vue&type=script&lang=ts&"
export * from "./RegistrationsTable.vue?vue&type=script&lang=ts&"
import style0 from "./RegistrationsTable.vue?vue&type=style&index=0&id=a7c75e9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c75e9c",
  null
  
)

export default component.exports